class LocalizationForm extends HTMLElement {
  constructor() {
    super();
    this.elements = {
      input: this.querySelector(
        'input[name="language_code"], input[name="country_code"]',
      ),
      button: this.querySelector("button"),
      panel: this.querySelector("ul"),
    };
    this.elements.button.addEventListener(
      "click",
      this.openSelector.bind(this),
    );
    this.elements.button.addEventListener(
      "focusout",
      this.closeSelector.bind(this),
    );
    this.addEventListener("keyup", this.onContainerKeyUp.bind(this));

    this.querySelectorAll("a").forEach((item) =>
      item.addEventListener("click", this.onItemClick.bind(this)),
    );
  }

  hidePanel() {
    this.elements.button.setAttribute("aria-expanded", "false");
    this.elements.panel.setAttribute("hidden", true);
  }

  onContainerKeyUp(event) {
    if (event.code.toUpperCase() !== "ESCAPE") return;

    this.hidePanel();
    this.elements.button.focus();
  }

  onItemClick(event) {
    event.preventDefault();
    const form = this.querySelector("form");
    this.elements.input.value = event.currentTarget.dataset.value;
    if (form) form.submit();
  }

  openSelector() {
    this.elements.button.focus();
    this.elements.panel.toggleAttribute("hidden");
    this.elements.button.setAttribute(
      "aria-expanded",
      (
        this.elements.button.getAttribute("aria-expanded") === "false"
      ).toString(),
    );
  }

  closeSelector(event) {
    const shouldClose =
      event.relatedTarget && event.relatedTarget.nodeName === "BUTTON";
    if (event.relatedTarget === null || shouldClose) {
      this.hidePanel();
    }
  }
}

customElements.define("localization-form", LocalizationForm);

async function fetchLocalizationSuggestions() {
  if (sessionStorage.getItem("localizationRedirected")) {
    console.log("logged localizationRedirected");
    return;
  }

  try {
    const response = await fetch(
      window.Shopify.routes.root +
        "browsing_context_suggestions.json" +
        "?country[enabled]=true" +
        `&country[exclude]=${window.Shopify.country}` +
        "&language[enabled]=true" +
        `&language[exclude]=${window.Shopify.language}`,
    );

    const data = await response.json();

    console.log(data);

    // Check if suggestions and parts are defined
    if (
      !data.suggestions ||
      !data.suggestions[0] ||
      !data.suggestions[0].parts
    ) {
      console.log("No localization suggestions found");
      return;
    }

    // Extract country and language suggestions
    const country = data.suggestions[0].parts.country;
    const language = data.suggestions[0].parts.language;

    if (!country || !language) {
      console.log("No localization suggestions found for country or language");
      return;
    }

    // Check if current localization already matches the suggestion
    const currentCountry = window.Shopify.country;
    const currentLanguage = window.Shopify.language;
    if (
      country.handle === currentCountry &&
      language.handle === currentLanguage
    ) {
      console.log(
        "Current localization already matches suggestion. No update needed.",
      );
      return;
    }

    const handle = country.handle;
    const name = country.name;

    function updateLocalization({ country, language }) {
      const formId = crypto.randomUUID();
      const formHtml = `
        <form id="${formId}" action="/localization" method="POST" hidden>
          <input name="_method" value="PUT">
          <input name="country_code" value="${country}">
          <input name="language_code" value="${language}">
        </form>
      `;
      document.body.insertAdjacentHTML("beforeend", formHtml);
      document.getElementById(formId).submit();
      // Optionally remove the form after submission
      document.getElementById(formId).remove();
    }

    console.log(
      `Localization updated to ${name} (${handle}) and ${language.name} (${language.handle})`,
    );
    sessionStorage.setItem("localizationRedirected", "true");
    updateLocalization({ country: handle, language: language.handle });
  } catch (error) {
    // Display a native browser error dialog
    console.error("Error fetching localization suggestions: " + error.message);
  }
}

fetchLocalizationSuggestions();
